<template>
  <div id="subject">
    <!-- begin page-header -->
    <h1 class="page-header">Daftar Mata Pelajaran</h1>
    <!-- end page-header -->

    <div class="row">
      <div class="col-md-4 col-sm-12" v-for="subject in subjects" v-bind:key="subject.id">
        <div class="widget widget-stats" v-bind:class="bgColor(subject.id)">
          <div class="stats-icon"><img :src="subject.picture" alt="subject-logo" style="max-width: 80px"></div>
          <div class="stats-info">
            <h4>Kode: {{subject.code}}</h4>
            <p>{{subject.name}}</p>
          </div>
          <div class="stats-link">
            <router-link :to="{path: '/topic-management/detail', query: { subject_id: subject.id }}">Lihat Bab <i class="fa fa-arrow-circle-o-right"></i></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ItemBankService from '@/services/itembank.js'

export default {
  name: 'subject-management',
  data: function () {
    return {
      subjects: [],
      bgColors: ['bg-green', 'bg-blue', 'bg-purple', 'bg-red']
    }
  },
  methods: {
    bgColor: function (id) {
      var index = id % 4
      return this.bgColors[index]
    }
  },
  mounted: function () {
    var context = this
    ItemBankService.getListMataPelajaran(function (response) {
      response.data.forEach(function(subject) {
        var data = {
          id: subject.id,
          code: subject.code,
          picture: !subject.picture ? 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png' : subject.picture,
          name: subject.nama.length > 20 ? subject.nama.substring(0, 19) + '...': subject.nama
        }

        context.subjects.push(data)
      })
    })
  }
}
</script>




// WEBPACK FOOTER //
// TopicManagement.vue?04dcab9c